import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: {},
  },
  mutations: {
    auth_success(state, user) {
      state.user = user;
    },
    logout(state) {
      state.user = {};
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.user?.email,
    email: (state) => state.user?.email,
    permissions: (state) => state.user?.permissions,
  },
  actions: {
    login({ commit }, user) {
      commit("auth_success", user);
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .post("/api/auth/logout", {})
          .then(() => {
            commit("logout");
            resolve();
          })
          .catch((e) => reject(e));
      });
    },
    loadUser({ commit }) {
      axios
        .post("/api/auth/check-auth")
        .then((resp) => {
          commit("auth_success", resp.data);
        })
        .catch(() => {});
    },
  },
});

export default store;
